import {getInitialState} from '../../helpers/initial-state'
import {useEnabledFeatures} from '../../hooks/use-enabled-features'

export function useIssueFieldsEnabled() {
  const {project_issue_fields} = useEnabledFeatures()
  const {isOrganization} = getInitialState()
  return Boolean(project_issue_fields && isOrganization)
}
